import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useEffect, useState} from 'react'
import styles from "./index.module.scss";
import logo from "../../images/index/logo.png";
import title from "../../images/index/title.png";
import { useStore } from "../../store/store";
import {getDefaultWarnMoneyApi} from '../../http/request'
import {useNavigate} from 'react-router-dom'
const variants = {
  container: {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  },
  card: {
    initial: {
      opacity: 0,
      x: -50,
    },

    animate: {
      opacity: 1,
      x: 0,
    },
  },
};
export default function Home() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate()
  const {buildingType,meterSetting,nkdSid,buildingName } =
  useStore((state) => state);
  const [defaultWarn, setDefaultWarn] = useState({
    coldWaterWarnMoney1:0,
    eleWarnMoney1: 0,
    hotWaterWarnMoney1: 0
  })
  const getDefaultWarnMoney = async () => {
    const res = await getDefaultWarnMoneyApi()
    if (res.data.code == 0) {
      setDefaultWarn({
        coldWaterWarnMoney1:res.data.coldWaterWarnMoney2,
    eleWarnMoney1: res.data.eleWarnMoney2,
    hotWaterWarnMoney1: res.data.hotWaterWarnMoney2,
      })
    }
  }
  useEffect(() => {
    console.log('buildingName',buildingName)
    if (!nkdSid) {
      navigate('/login')
      return
    }
    document.title = t('SM')
    getDefaultWarnMoney()
  },[])
  return (
    <div className={styles.main_container}>
      <div className={styles.background_line}></div>
      <img src={title}  className={styles.title} alt="" />
      {i18n.language == "zh" ? (
        <motion.div
          className={styles.content_view}
          initial="initial"
          animate="animate"
          variants={variants.container}
        >
          <motion.p variants={variants.card}>
            {`一、本系统是智能化的"预付费购水/购电"模式,
              先充值,后用水电。如房间欠费,微信充值后,系统一般在10分钟内自动恢复供水电,充值后最新的水电余量数据请在60分钟后查看。 `}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            二、根据南科大 (2017)
            22号文件规定,对在校学生实施配额用电(2017级及以后每生每月10度),每年分两次于学期初发放。超额部分按照校内标准收费。{" "}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            三、收费标准:&nbsp;&nbsp; 电费{meterSetting.electricityPrice}元/度, 水费{meterSetting.coldWaterPrice}元/立方米。{" "}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            四、余额提醒设置:&nbsp;&nbsp;系统默认当电表余量低于{defaultWarn.eleWarnMoney1}元,1号水表余量低于{defaultWarn.coldWaterWarnMoney1}元,2号水表余量低于{defaultWarn.hotWaterWarnMoney1}元时,系统每天08:00和18:00会发送充值提醒到微信绑定用户。
            用户欠电费时停电，欠水费时停水(<span style={{color: 'red'}}>教师公寓有两路进水管道,1号水表为主用水表,2号水表为阳台水表,房间欠电费、或者1号水表或2号水表欠水费时均停电</span>)。{" "}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            五、教职工和学生可以通过学校企业微信号或到校园圈存机充值;工作时间可到生活服务中心(教师公寓3栋1楼)协助充值。友情提醒,对于即将离校或调换房间的用户,建议您根据使用情况适量充值。{" "}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            六、故障报修,请拨打客服电话:
            88010123或者工作时间到生活服务中心咨询。{" "}
          </motion.p>
          <div className={styles.footer}>
            <p>总务后勤部</p>
            <p>2025年7月3日</p>
            <img src={logo}  className={styles.logo} alt="" />
          </div>
        </motion.div>
      ) : (
        <motion.div
          className={styles.content_view}
          initial="initial"
          animate="animate"
          variants={variants.container}
        >
          <motion.p variants={variants.card}>
            {`First, This syatem is an intelligent "prapaid watur/elecinery purchase"mode, which unas waler and electricity after recharging.  If the room is in arrears, the system will
autoratically restore water and electricity supply within 10 minutes after WeChat recharge;  Please check the latest  waler and electricity balance data after recharging in 60 miniites.`}
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            Second, According to the provisions of the document No. 22[2017] of
            the South University of Selence and Technology, the quota of
            electricity use (10 degrans per month for each student in 2017 and
            later) is implemented for students in school, which is distributed
            twice a year at the beginning of the semester. The excess is charged
            according to the schoostandard.
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            Third, Charging standard: {meterSetting.electricityPrice} yuan/kWh for electricity;Water
            charge is {meterSetting.coldWaterPrice} yuan/m3.
          </motion.p>
          <br />
          <motion.p variants={variants.card}>
            Forth,Balance Reminder Settings: By default, when the balance of
            electricity meter is less than {defaultWarn.eleWarnMoney1} yuan, the balanceof of NO.1 water
            meter is less than {defaultWarn.coldWaterWarnMoney1} yuan, and the balance of NO.2 water meter is
            less than {defaultWarn.hotWaterWarnMoney1} yuan, the system will send arecharge reminder to WeChat
            bound users.{" "}
            {buildingName?.includes("教师公寓") || buildingName?.includes("创园")
              ? <>When the user owes water or electricity bills, the system will cut off the power supply (<span style={{color: 'red'}}>the teacher apartment has two water inlet pipes, the No. 1 water meter is the main water meter, the No. 2 water meter is the balcony water meter. When the user owes electricity or water bills, the power will be cut off</span>)</>
              : "The power is cut off when the user owes the electricity bill and the water is cut off when the user owes the water bill"
            }.
          </motion.p>
          <br />
          <motion.p
            variants={variants.card}
          >{`Fifth,Staff and students can recharge through the school's corporate wechat account or go to the campus circle deposit machine
          ;  During working hours, you can go to the life service center (the first floor of the third building of the teachers' apartment) to help recharge.  Friendly reminder: For users who are about to leave school or change rooms, it is recommended that you recharge appropriately according tothe usage.`}</motion.p>
          <br />
          <motion.p variants={variants.card}>
            Sixth, For fault repair, please call the customer service hotline:
            88010123 or visit the life service center during working hours.
          </motion.p>
          <div className={styles.footer}>
            <p>Facilities and Campus Services Office</p>
            <p>July 3rd, 2025</p>
            <img src={logo}  className={styles.logo} alt="" />
          </div>
        </motion.div>
      )}
    </div>
  );
}
